export const RADIUS_CATALOG: Array<{ key: string; label: string; className: string }> = [
  { key: "none", label: "none", className: "rounded-none" },
  { key: "sm", label: "sm", className: "rounded-sm" },
  { key: "md", label: "md", className: "rounded-md" },
  { key: "lg", label: "lg", className: "rounded-lg" },
  { key: "xl", label: "xl", className: "rounded-xl" },
  { key: "2xl", label: "2xl", className: "rounded-2xl" },
  { key: "full", label: "full", className: "rounded-full" },
];
